import request from '@/utils/request';
import Resource from '@/api/resource';
class InterestActionResource extends Resource {
  constructor() {
    super('tool/interestAction/jrtt');
  }

  // 查询行为类目
  getActionCategoryApi(data) {
    return request({
      url: `/${this.uri}/getActionCategory`,
      method: 'get',
      params: data,
    });
  }

  // 查询行为关键词
  getActionKeywordApi(data) {
    return request({
      url: `/${this.uri}/getActionKeyword`,
      method: 'get',
      params: data,
    });
  }

  // 查询兴趣类目
  getInterestCategoryApi(data) {
    return request({
      url: `/${this.uri}/getInterestCategory`,
      method: 'get',
      params: data,
    });
  }

  // 查询兴趣关键词
  getInterestKeywordApi(data) {
    return request({
      url: `/${this.uri}/getInterestKeyword`,
      method: 'get',
      params: data,
    });
  }

  // 兴趣行为类目关键词id转词接口
  id2wordApi(data) {
    return request({
      url: `/${this.uri}/id2word`,
      method: 'get',
      params: data,
    });
  }

  // 获取行为兴趣推荐关键词接口
  keywordSuggestApi(data) {
    return request({
      url: `/${this.uri}/keywordSuggest`,
      method: 'get',
      params: data,
    });
  }

  // 批量添加行为接口
  bacthAddActoionApi(data) {
    return request({
      url: `/${this.uri}/batchAddAction`,
      method: 'POST',
      data,
    });
  }

  // 批量添加兴趣接口
  bacthAddInterestApi(data) {
    return request({
      url: `/${this.uri}/batchAddInterest`,
      method: 'POST',
      data,
    });
  }
}
export { InterestActionResource as default };
